import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ApiRequestsService } from '../../services/api-requests.service';

interface Notification {
  id: number;
  title: string;
  message: string;
  time: string;
  icon?: string;
  read: boolean;
}

@Component({
  selector: 'app-default-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './default-header.component.html',
  styleUrl: './default-header.component.scss',
})
export class DefaultHeaderComponent implements OnInit {
  isClassAdded = false;
  @Output() toggleSidebar = new EventEmitter<void>();

  notifications: Notification[] = [];

  get unreadCount(): number {
    return this.notifications.filter(n => !n.read).length;
  }

  markRead(n: Notification): void {
    n.read = true;
  }

  markAllRead(): void {
    this.notifications.forEach(n => (n.read = true));
  }

  constructor(public apiService: ApiRequestsService) {}
  ngOnInit(): void {}

  onToggleSidebar() {
    this.toggleSidebar.emit();
  }

  toggleClsss() {
    this.isClassAdded = !this.isClassAdded;
  }

  logout() {
    this.apiService.logout();
  }

  getInitials(userName: string): string {
    if (!userName) {
      return '?';
    }
    const parts = userName.trim().split(/\s+/);
    const initials = parts.length > 1 ? parts[0][0] + parts[parts.length - 1][0] : parts[0].slice(0, 2);
    return initials.toUpperCase();
  }
}
